import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail, Car, MessageCircle } from 'lucide-react';
import { BUSINESS_INFO, NAV_LINKS } from '../../utils/constants';
import Button from '../ui/Button';
import WhatsAppIcon from '../ui/WhatsAppIcon';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  return (
    <header className={`header ${scrolled ? 'header-scrolled' : ''}`}>
      <div className="header-top hide-mobile">
        <div className="container">
          <div className="flex justify-between items-center">
            <div className="flex gap-lg">
              <a href={BUSINESS_INFO.whatsappLink} target="_blank" rel="noopener noreferrer">
                <Phone size={14} />
                {BUSINESS_INFO.phoneDisplay}
              </a>
              <a href={`mailto:${BUSINESS_INFO.email}`}>
                <Mail size={14} />
                {BUSINESS_INFO.email}
              </a>
            </div>
            <div style={{ fontSize: '0.8125rem' }}>
              Mon–Fri: 10:00–20:00 &nbsp;|&nbsp; Sat–Sun: 10:00–18:00
            </div>
          </div>
        </div>
      </div>

      <div className="header-main">
        <div className="container">
          <div className="flex justify-between items-center">
            <Link to="/" className="header-logo">
              <img
                src="/assets/images/logo.png"
                alt="ARA Mobile Valeting"
                onError={(e) => {
                  e.target.style.display = 'none';
                  const carIcon = e.target.nextElementSibling;
                  if (carIcon) carIcon.style.display = 'block';
                }}
              />
              <Car size={36} style={{ display: 'none', color: 'var(--gold)' }} />
              <div className="header-logo-text">
                <h1>ARA</h1>
                <p>Mobile Valeting</p>
              </div>
            </Link>

            <nav className="header-nav hide-mobile">
              {NAV_LINKS.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={location.pathname === link.path ? 'active' : ''}
                >
                  {link.label}
                </Link>
              ))}
            </nav>

            <div className="hide-mobile">
              <a href={BUSINESS_INFO.whatsappLink} target="_blank" rel="noopener noreferrer">
                <Button variant="primary" size="sm" icon={WhatsAppIcon}>
                  Book Now
                </Button>
              </a>
            </div>

            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="mobile-menu-btn hide-desktop"
              aria-label="Toggle menu"
              aria-expanded={mobileMenuOpen}
            >
              {mobileMenuOpen ? <X size={26} /> : <Menu size={26} />}
            </button>
          </div>

          {mobileMenuOpen && (
            <div className="mobile-menu open">
              <nav>
                {NAV_LINKS.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    className={location.pathname === link.path ? 'active' : ''}
                  >
                    {link.label}
                  </Link>
                ))}
                <a
                  href={BUSINESS_INFO.whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginTop: '0.75rem' }}
                >
                  <Button variant="whatsapp" icon={WhatsAppIcon} className="w-full">
                    Book on WhatsApp
                  </Button>
                </a>
              </nav>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;